module.exports = __webpack_public_path__ + "img/geo-alt-fill.313141a8.svg";